import Vue from 'vue'

const mutations = {
  SET_PERCENTAGE_OF_LOADS(state, percentageOfLoads) {
    Vue.set(state, 'percentageOfLoads', percentageOfLoads);    
  },

  SET_COMPANY_TYPES(state, types) {
    Vue.set(state, 'companyTypes', types);    
  },

  SET_ROLES(state, roles) {
    Vue.set(state, 'roles', roles);    
  },

  SET_ENERGY_TYPES(state, energies) {
    Vue.set(state, 'energyTypes', energies);
  },

  SET_NODE_TYPES(state, nodeTypes) {
    Vue.set(state, 'nodeTypes', nodeTypes);
  },

  SET_ENERGY_METER_TYPES(state, energyTypes) {
    Vue.set(state, 'energyMeterTypes', energyTypes);
  },

  SET_TRANSPORT_TECHNOLOGIES(state, technologies) {
    Vue.set(state, 'transportTechnologies', technologies);
  },

  SET_LOG_ACTIONS(state, actions) {
    Vue.set(state, 'logActions', actions);
  },

  SET_LOG_OBJECTS(state, objects) {
    Vue.set(state, 'logObjects', objects);
  },

  SET_RECORD_TYPES(state, records) {
    Vue.set(state, 'recordTypes', records);
  },

  SET_PERIOD_TYPES(state, types) {
    Vue.set(state, 'periodTypes', types);
  },

  /*SET_PROJECT_GROUPS(state, groups) {
    Vue.set(state, 'projectGroups', groups);
  },*/

  SET_PROJECT_TYPES(state, types) {
    Vue.set(state, 'projectTypes', types);
  },

  SET_EXPORT_PROVIDERS_TYPES(state, types) {
    Vue.set(state, 'exportProvidersTypes', types);
  },

  SET_TASK_TYPES(state, types) {
    Vue.set(state, 'taskTypes', types);
  },

  SET_PAPER_ACT_TYPES(state, types) {
    Vue.set(state, 'paperActTypes', types);
  },
}

export default mutations